//@author: devin
import { SearchCriteriaContext } from "./search.criteria.context";

export class SearchCriteriaAdvContext {
    public static Context: any = {
        //security groups
        99: SearchCriteriaContext.Context.securityGroups, //security groups

        //events
        101000: SearchCriteriaContext.Context.assignedEventStates, //event states
        101: SearchCriteriaContext.Context.eventStates, //event states
        102: SearchCriteriaContext.Context.eventTypes, //event types
        103: SearchCriteriaContext.Context.eventTypes, //event types
        104: SearchCriteriaContext.Context.eventFolders, //event folders
        105: SearchCriteriaContext.Context.eventCabinets, //event cabinets
        107: SearchCriteriaContext.Context.events, //events
        108: SearchCriteriaContext.Context.eventSearches, //event searches
        192: SearchCriteriaContext.Context.eventSearches, //event searches
        110: SearchCriteriaContext.Context.organizations, //organizations
        112: SearchCriteriaContext.Context.organizations, //organizations
        111: SearchCriteriaContext.Context.contacts, //contacts
        185: SearchCriteriaContext.Context.contacts, //attendees
        113: SearchCriteriaContext.Context.organizationSearches, //organization searches
        120: SearchCriteriaContext.Context.eventCategories, //event categories
        121: SearchCriteriaContext.Context.eventCategories, //event categories
        130: SearchCriteriaContext.Context.eventRequirements, //event requirements
        131: SearchCriteriaContext.Context.eventRequirements, //event requirements
        162: SearchCriteriaContext.Context.locationSearches, //location searches
        163: SearchCriteriaContext.Context.locations, //locations
        165: SearchCriteriaContext.Context.locations, //locations (for searching location preferences)
        167: SearchCriteriaContext.Context.resourceSearches, //resource searches
        168: SearchCriteriaContext.Context.resources, //resources
        150: SearchCriteriaContext.Context.eventCustomAttributes,

        //locations
        20: SearchCriteriaContext.Context.locationRelatedTypes, //include related locations (sub div, close to, divides into...)
        471: SearchCriteriaContext.Context.events, //events
        470: SearchCriteriaContext.Context.eventSearches, //event searches
        405: SearchCriteriaContext.Context.locationSearches, //location searches
        407: SearchCriteriaContext.Context.locations, //locations
        410: SearchCriteriaContext.Context.locationFeatures, //location features
        411: SearchCriteriaContext.Context.locationFeatures, //location features
        420: SearchCriteriaContext.Context.locationCategories, //location categories
        421: SearchCriteriaContext.Context.locationCategories, //location categories
        423: SearchCriteriaContext.Context.locationPartitions, //location partitions
        424: SearchCriteriaContext.Context.locationPartitions, //location partitions
        430: SearchCriteriaContext.Context.locationLayouts, //location layouts
        433: SearchCriteriaContext.Context.locationLayouts, //location layouts
        460: SearchCriteriaContext.Context.locations, //related spaces (locations)
        461: SearchCriteriaContext.Context.locations, //related spaces (locations)
        450: SearchCriteriaContext.Context.locationCustomAttributes,

        //resources
        671: SearchCriteriaContext.Context.events, //events
        670: SearchCriteriaContext.Context.eventSearches, //event searches
        605: SearchCriteriaContext.Context.resourceSearches, //resource searches
        607: SearchCriteriaContext.Context.resources, //resources
        6071: SearchCriteriaContext.Context.resourcesQuantity, // include="quantity"
        620: SearchCriteriaContext.Context.resourceCategories, //category id
        621: SearchCriteriaContext.Context.resourceCategories, //category id
        660: SearchCriteriaContext.Context.resources, //related resources (resources)
        661: SearchCriteriaContext.Context.resources, //related resources (resources)
        650: SearchCriteriaContext.Context.resourceCustomAttributes,

        //organizations
        207: SearchCriteriaContext.Context.organizations, //organizations
        205: SearchCriteriaContext.Context.organizationSearches, //organization searches
        220: SearchCriteriaContext.Context.organizationCategories, //organization categories
        221: SearchCriteriaContext.Context.organizationCategories, //organization categories
        210: SearchCriteriaContext.Context.contacts, //contacts
        230: SearchCriteriaContext.Context.organizationTypes, //organization types
        231: SearchCriteriaContext.Context.organizationTypes, //organization types
        280: SearchCriteriaContext.Context.organizationRatings, //organization ratings
        281: SearchCriteriaContext.Context.organizationRatings, //organization ratings
        271: SearchCriteriaContext.Context.events, //events
        270: SearchCriteriaContext.Context.eventSearches, //event searches
        250: SearchCriteriaContext.Context.organizationCustomAttributes,

        8001: SearchCriteriaContext.Context.ingestionFieldsAll,
        9001: SearchCriteriaContext.Context.workflowProcesses,
    };
}
